(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerSticky = document.querySelector('.header');
      this.utilityBar = document.querySelector('.utility-bar');
      this.countdownBar = document.querySelector('.countdown-bar-section');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight(true);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      // Bind once and store references so removeEventListener works reliably
      this.onResizeHandler = this.onResize.bind(this);
      this.onMediaChangeHandler = this.onResize.bind(this);
      this.mediaQuery = window.matchMedia('(max-width: 1199px)');
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      window.addEventListener('resize', this.onResizeHandler);
      this.mediaQuery.addEventListener('change', this.onMediaChangeHandler);

      this.createObserver();
    }

    // setHeaderHeight() {
    //   this.headerHeight = this.headerSticky.offsetHeight;
    //   console.log(this.headerHeight,"this.headerHeight");
    //   document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    // }

    setHeaderHeight(includeAnnouncement = true) {
      const headerHeight = this.headerSticky?.offsetHeight || 0;
      const announcementHeight = includeAnnouncement ? this.utilityBar?.offsetHeight || 0 : 0;
      const countdownHeight = includeAnnouncement ? this.countdownBar?.offsetHeight || 0 : 0;

      this.headerHeight = headerHeight + announcementHeight + countdownHeight - 6;

      // Main header height only (excludes announcement + countdown bars)
      document.documentElement.style.setProperty('--main-header-height', `${headerHeight}px`);

      document.documentElement.style.setProperty(
        '--header-height',
        `${this.headerHeight}px`
      );
    }

    onResize() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const shouldIncludeAnnouncement = scrollTop <= this.headerHeight;
      this.setHeaderHeight(shouldIncludeAnnouncement);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('resize', this.onResizeHandler);
      if (this.mediaQuery && this.onMediaChangeHandler) {
        this.mediaQuery.removeEventListener('change', this.onMediaChangeHandler);
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.headerHeight) {
        // Sticky state → exclude announcement bar
        this.setHeaderHeight(false);
      } else {
        // Normal state → include announcement bar
        this.setHeaderHeight(true);
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerHeight) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerHeight) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerHeight) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
